import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  makePeerConsumerSelector,
  passiveMicConsumerSelector,
} from "../Selectors";
import PropTypes from "prop-types";
import classnames from "classnames";
import * as appPropTypes from "../appPropTypes";
import { withRoomContext } from "../../RoomContext";
import { withStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import * as roomActions from "../../actions/roomActions";
import { useIntl } from "react-intl";
import VideoView from "../VideoContainers/VideoView";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import NewWindowIcon from "@material-ui/icons/OpenInNew";
import FullScreenIcon from "@material-ui/icons/Fullscreen";
import Volume from "./Volume";
import Assets from "../../assets";
import PeerStatistics from "../PeerStatistics/PeerStatistics";
import More from "@material-ui/icons/More";
import ReactDOM from 'react-dom';
import { useRef } from "react";

const styles = (theme) => ({
  root: {
    minHeight: 100,
    flex: "0 0 auto",
    boxShadow: "var(--peer-shadow)",
    border: "var(--peer-border)",
    touchAction: "none",
    backgroundColor: "var(--peer-bg-color)",
    backgroundImage: "var(--peer-empty-avatar)",
    backgroundPosition: "bottom",
    backgroundSize: "auto 85%",
    backgroundRepeat: "no-repeat",
    borderRadius: 16,
    "&.hover": {
      boxShadow:
        "0px 1px 3px rgba(0, 0, 0, 0.05) inset, 0px 0px 8px rgba(82, 168, 236, 0.9)",
    },
    "&.active-speaker": {
      // transition  : 'filter .2s',
      // filter      : 'grayscale(0)',
      borderWidth: 2,
      borderColor: "var(--active-speaker-border-color)",
    },
    "&:not(.active-speaker):not(.screen)": {
      // transition : 'filter 10s',
      // filter     : 'grayscale(0.75)'
    },
    "&.webcam": {
      order: 4,
      backgroundPositionY: "center"
    },
    "&.screen": {
      order: 3,
    },
  },
  fab: {
    margin: theme.spacing(1),
    cursor: "pointer"
  },
  viewContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  controls: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    display: "none",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
    padding: theme.spacing(1),
    zIndex: 21,
    opacity: 0,
    transition: "opacity 0.3s",
    borderRadius: 16,
    touchAction: "none",
    "&.hover": {
      display: "flex",
      opacity: 1,
    },
  },
  videoInfo: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(1),
    zIndex: 20,
    "& p": {
      padding: "6px 12px",
      borderRadius: 6,
      userSelect: "none",
      pointerEvents: "none",
      fontSize: 20,
      color: "rgba(255, 255, 255, 0.55)",
    },
  },
  pinningIcon: {
    position: "absolute",
    margin: theme.spacing(1),
    zIndex: 22,
  },
});

const Peer = (props) => {
  const [hover, setHover] = useState(false);
  const [hoverMenu, setHoverMenu] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [pos, setPos] = useState([0, 0]);
  const [watch, setWatch] = useState(false);
  const intl = useIntl();

  let touchTimeout = null;

  const {
    roomClient,
    advancedMode,
    peer,
    activeSpeaker,
    micConsumer,
    webcamConsumer,
    screenConsumer,
    toggleConsumerFullscreen,
    toggleConsumerWindow,
    spacing,
    style,
    room,
    //smallButtons,
    windowConsumer,
    classes,
    theme,
    isAdmin,
    isVirtualClassroomSFU,
    mode,
    click,
    isModerator,
    lastN,
    screenPin,
    screenPinnedPeerLength
  } = props;
  let smallButtons = true;

  const micEnabled =
    Boolean(micConsumer) &&
    !micConsumer.locallyPaused &&
    !micConsumer.remotelyPaused;

  const remoteMicEnabled = Boolean(micConsumer) && !micConsumer.remotelyPaused;

  const videoVisible =
    Boolean(webcamConsumer) &&
    !webcamConsumer.locallyPaused &&
    !webcamConsumer.remotelyPaused;

  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  let refRoot = useRef();
  let refControl = useRef();

  // Kontrol tuşlarının ekranda belireceği pozsiyon
  useEffect(() => {
    if (!refRoot.current || !refControl.current) { return; }
    let refRootRect = refRoot.current.getBoundingClientRect();
    let refControlsRect = refControl.current.getBoundingClientRect();

    let x = refRootRect.x + refRootRect.width - refControlsRect.width - 10;
    let y = refRootRect.y + (refRootRect.height / 2) - (refControlsRect.height / 2);

    if (y < 0) { y = 10; }
    if (y + refControlsRect.height > window.innerHeight) { y = window.innerHeight - refControlsRect.height - 10}

    setPos([x, y]);
  }, [hoverMenu]);

  // Peer üzerine gelindiğinde
  const setHoverCombine = () => {
    setHover(true);
    setHoverMenu(true);
  }

  // peer üzerinden ayrıldığında
  const setHoverOutCombine = () => {
    setHover(false);
    if (watch === false) {
      setHoverMenu(false);
    }
  }

  // Eğer fare kontrolcü üstünden ayrıldığında
  // root element üzerinde mi kontrol et.
  const setLeave = (e) => {
    if (!refRoot.current || !refControl.current) { return; }
    let refRootRect = refRoot.current.getBoundingClientRect();
    setWatch(false);
    if (e.clientX >= refRootRect.x && e.clientX <= refRootRect.x + refRootRect.width &&
      e.clientY >= refRootRect.y && e.clientY <= refRootRect.y + refRootRect.height) {

    } else {
      setHover(false);
      setHoverMenu(false);
    }
  }

  if (!peer) return null;

  const rootStyle = {
    margin: spacing,
    ...style,
  };

  if (isAdmin || isVirtualClassroomSFU || !room.webinar || room.webinar)
    return (
      <React.Fragment>
        {room.webinar &&
          screenConsumer &&
          !webcamConsumer &&
          !isVirtualClassroomSFU ? null : (
          <div
            ref={refRoot}
            className={classnames(
              classes.root,
              "webcam",
              hover && "hover",
              activeSpeaker && "active-speaker"
            )}
            onMouseEnter={() => setHoverCombine()}
            onMouseLeave={() => setHoverOutCombine()}
            onTouchStart={() => {
              if (touchTimeout) clearTimeout(touchTimeout);

              setHover(true);
            }}
            onTouchEnd={() => {
              if (touchTimeout) clearTimeout(touchTimeout);

              touchTimeout = setTimeout(() => {
                setHover(false);
              }, 2000);
            }}
            style={rootStyle}
          >
            <div className={classnames(classes.viewContainer)}>
              {Boolean(peer.screenPin) && (
                <div className={classes.pinningIcon}>
                  <img src={Assets.Containers.pinIcon} />
                </div>
              )}
              <div
                className={classnames(classes.controls, hover && "hover")}
              >
                {
                  hoverMenu &&
                  ReactDOM.createPortal(
                    <div
                      ref={refControl}
                      onMouseEnter={() => setWatch(true)}
                      onMouseLeave={(e) => setLeave(e)}
                      style={{
                        position: "absolute",
                        left: pos[0],
                        top: pos[1],
                        zIndex: 999999, borderRadius: 25, backgroundColor: "rgba(197,197,197,0.3)"
                      }}>
                      {!room.hasInterpreterSupporting && (
                        <Tooltip
                          title={intl.formatMessage({
                            id: "device.muteAudio",
                            defaultMessage: "Mute audio",
                          })}
                          placement={smallScreen ? "top" : "left"}
                        >
                          <div>
                            <Fab
                              aria-label={intl.formatMessage({
                                id: "device.muteAudio",
                                defaultMessage: "Mute audio",
                              })}
                              className={classes.fab}
                              disabled={!micConsumer}
                              color={micEnabled ? "default" : "secondary"}
                              size={smallButtons ? "small" : "large"}
                              onClick={() =>
                                roomClient.modifyPeerMicConsumer(peer.id, micEnabled)
                              }
                            >
                              {micEnabled ? <VolumeUpIcon /> : <VolumeOffIcon />}
                            </Fab>
                          </div>
                        </Tooltip>
                      )}

                      {!smallScreen && (
                        <Tooltip
                          title={intl.formatMessage({
                            id: "label.newWindow",
                            defaultMessage: "New window",
                          })}
                          placement={smallScreen ? "top" : "left"}
                        >
                          <div>
                            <Fab
                              aria-label={intl.formatMessage({
                                id: "label.newWindow",
                                defaultMessage: "New window",
                              })}
                              className={classes.fab}
                              disabled={
                                !videoVisible || windowConsumer === webcamConsumer.id
                              }
                              size={smallButtons ? "small" : "large"}
                              onClick={() => {
                                toggleConsumerWindow(webcamConsumer);
                              }}
                            >
                              <NewWindowIcon />
                            </Fab>
                          </div>
                        </Tooltip>
                      )}

                      <Tooltip
                        title={intl.formatMessage({
                          id: "label.fullscreen",
                          defaultMessage: "Fullscreen",
                        })}
                        placement={smallScreen ? "top" : "left"}
                      >
                        <div>
                          <Fab
                            aria-label={intl.formatMessage({
                              id: "label.fullscreen",
                              defaultMessage: "Fullscreen",
                            })}
                            className={classes.fab}
                            disabled={!videoVisible}
                            size={smallButtons ? "small" : "large"}
                            onClick={() => {
                              toggleConsumerFullscreen(webcamConsumer);
                            }}
                          >
                            <FullScreenIcon />
                          </Fab>
                        </div>
                      </Tooltip>

                      <Tooltip
                        title={intl.formatMessage({
                          id: "label.more",
                          defaultMessage: "More",
                        })}
                        placement={smallScreen ? "top" : "left"}
                      >
                        <div>
                          <Fab
                            aria-label={intl.formatMessage({
                              id: "label.more",
                              defaultMessage: "More",
                            })}
                            className={classes.fab}
                            disabled={!videoVisible}
                            size={smallButtons ? "small" : "large"}
                            onClick={() => {
                              setShowStats(!showStats)
                            }}
                          >
                            <More />
                          </Fab>
                        </div>
                      </Tooltip>

                      {
                        isModerator &&
                        (
                          !screenPin ?
                            (
                              <Tooltip
                                title={intl.formatMessage({
                                  id: "label.pin",
                                  defaultMessage: "Pin",
                                })}
                                placement={smallScreen ? "top" : "left"}
                              >
                                <div>
                                  <Fab
                                    aria-label={intl.formatMessage({
                                      id: "label.pin",
                                      defaultMessage: "Pin",
                                    })}
                                    className={classes.fab}
                                    size={smallButtons ? "small" : "large"}
                                    onClick={() => {
                                      roomClient.toggleScreenPin(peer.id, true);
                                      if (screenPinnedPeerLength === lastN) {
                                        roomClient.changeMaxSpotlights(lastN + 1);
                                      }
                                    }}
                                  >
                                    <img src={Assets.MeetingDrawer.ParticipantList.unpinIcon} />
                                  </Fab>
                                </div>
                              </Tooltip>
                            ):
                            (
                              <Tooltip
                                title={intl.formatMessage({
                                  id: "label.unpin",
                                  defaultMessage: "Unpin",
                                })}
                                placement={smallScreen ? "top" : "left"}
                              >
                                <div>
                                  <Fab
                                    aria-label={intl.formatMessage({
                                      id: "label.unpin",
                                      defaultMessage: "Unpin",
                                    })}
                                    className={classes.fab}
                                    size={smallButtons ? "small" : "large"}
                                    onClick={() => {
                                      roomClient.toggleScreenPin(peer.id, false);
                                    }}
                                  >
                                    <img src={Assets.MeetingDrawer.ParticipantList.pinIcon} />
                                  </Fab>
                                </div>
                              </Tooltip>
                            )
                        )
                      }
                    </div>
                    , document.body)
                }
              </div>
              {webcamConsumer && showStats && (<PeerStatistics consumer={webcamConsumer.consumer} score={webcamConsumer.score.producerScore} />)}
              <VideoView
                advancedMode={advancedMode}
                peer={peer}
                displayName={peer.displayName}
                showPeerInfo
                consumerSpatialLayers={
                  webcamConsumer ? webcamConsumer.spatialLayers : null
                }
                consumerTemporalLayers={
                  webcamConsumer ? webcamConsumer.temporalLayers : null
                }
                consumerCurrentSpatialLayer={
                  webcamConsumer ? webcamConsumer.currentSpatialLayer : null
                }
                consumerCurrentTemporalLayer={
                  webcamConsumer ? webcamConsumer.currentTemporalLayer : null
                }
                consumerPreferredSpatialLayer={
                  webcamConsumer ? webcamConsumer.preferredSpatialLayer : null
                }
                consumerPreferredTemporalLayer={
                  webcamConsumer ? webcamConsumer.preferredTemporalLayer : null
                }
                videoMultiLayer={
                  webcamConsumer && webcamConsumer.type !== "simple"
                }
                videoTrack={webcamConsumer && webcamConsumer.track}
                videoVisible={videoVisible}
                audioTrack={micConsumer && micConsumer.track}
                audioCodec={micConsumer && micConsumer.codec}
                videoCodec={webcamConsumer && webcamConsumer.codec}
                audioScore={micConsumer ? micConsumer.score : null}
                videoScore={webcamConsumer ? webcamConsumer.score : null}
                micOff={!remoteMicEnabled}
              >
                <Volume id={peer.id} />
              </VideoView>

            </div>
          </div>
        )}
      </React.Fragment>
    );
  else return null;
};

Peer.defaultProps = {
  isAdmin: false,
  isVirtualClassroomSFU: false,
};
Peer.propTypes = {
  roomClient: PropTypes.any.isRequired,
  room: appPropTypes.Room.isRequired,
  advancedMode: PropTypes.bool,
  peer: appPropTypes.Peer,
  micConsumer: appPropTypes.Consumer,
  webcamConsumer: appPropTypes.Consumer,
  screenConsumer: appPropTypes.Consumer,
  windowConsumer: PropTypes.string,
  activeSpeaker: PropTypes.bool,
  spacing: PropTypes.number,
  style: PropTypes.object,
  smallButtons: PropTypes.bool,
  toggleConsumerFullscreen: PropTypes.func.isRequired,
  toggleConsumerWindow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool,
  isVirtualClassroomSFU: PropTypes.bool,
  mode: PropTypes.object,
  screenPin: PropTypes.bool,
  screenPinnedPeerLength: PropTypes.number,
  lastN: PropTypes.number,
};

const makeMapStateToProps = (initialState, { id }) => {
  const getPeerConsumers = makePeerConsumerSelector();

  const mapStateToProps = (state) => {
    const screenPinnedPeerLength = Object.values(state.peers).filter(
      (peer) => peer.screenPin
    ).length;
    return {
      peer: state.peers[id],
      ...getPeerConsumers(state, id),
      windowConsumer: state.room.windowConsumer,
      activeSpeaker: id === state.room.activeSpeakerId,
      micConsumers: passiveMicConsumerSelector(state),
      room: state.room,
      mode: state.room.mode,
      lastN: state.settings.lastN,
      screenPin: state.peers[id] ? Boolean(state.peers[id].screenPin) : false,
      screenPinnedPeerLength,
      isModerator: state.me.roles.some((role) =>
        state.room.permissionsFromRoles.MODERATE_ROOM.includes(role)
      ),
    };
  };

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleConsumerFullscreen: (consumer) => {
      if (consumer) dispatch(roomActions.toggleConsumerFullscreen(consumer.id));
    },
    toggleConsumerWindow: (consumer) => {
      if (consumer) dispatch(roomActions.toggleConsumerWindow(consumer.id));
    },
  };
};

export default withRoomContext(
  connect(makeMapStateToProps, mapDispatchToProps, null, {
    areStatesEqual: (next, prev) => {
      return (
        prev.room === next.room &&
        prev.peers === next.peers &&
        prev.consumers === next.consumers &&
        prev.room.activeSpeakerId === next.room.activeSpeakerId &&
        prev.room.windowConsumer === next.room.windowConsumer &&
        prev.room.spotlights === next.room.spotlights
      );
    },
  })(withStyles(styles, { withTheme: true })(Peer))
);
